'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { getQueryClient } from '@/lib/queryClient';

const ReactQueryProvider = ({ children }: { children: React.ReactNode }) => {
  // getQueryClient returns the one browser client, so the cache the hooks use
  // is the same one the zustand stores read and write outside React.
  const [queryClient] = useState(getQueryClient);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default ReactQueryProvider;
